// import React, { useState, useEffect } from "react";
// import { MainLayout } from "../components/layout/MainLayout";
// import { FolderPlus, RefreshCw } from "lucide-react";
// import ErrorBanner from "../components/common/ErrorBanner";
// import Card from "../components/common/Card";
// import SectionHeader from "../components/common/SectionHeader";
// import PrimaryButton from "../components/ui/PrimaryButton";
// import apiClient from "../components/utils/apiClient";
// import { useParams } from "react-router-dom";
// import {
//   ProjectInfoService,
//   ProjectInfoFields,
// } from "../components/services/ProjectInfoService";
// import AssetListManager from "./AssetListManager";
// import DraggableFloorManager from "./DraggableFloorManager";
// import BulkUploadManager from "./BulkUploadManager";
// import PvUploadManager from "./PvUploadManager";
// import {
//   PushNotification,
//   PushNotificationManager,
//   NotificationSoundProvider,
// } from "./PushNotification";

// const SceneAssetManager = () => {
//   const { projectId } = useParams();

//   const [projectData, setProjectData] = useState({
//     ceilingList: [],
//     floorList: [],
//     externalList: [],
//     internalList: [],
//     doorsList: [],
//     stairsList: [],
//     pvList: [],
//   });
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const [notifications, setNotifications] = useState([]);

//   const [showBulkUpload, setShowBulkUpload] = useState(false);

//   const [showPvUpload, setShowPvUpload] = useState(false);

//   useEffect(() => {
//     fetchProjectData();

//     setNotifications([
//       {
//         id: "feature-floor-deletion",
//         title: "New Feature: Floor Deletion",
//         message:
//           "When you delete a floor from the Floor List, all related assets (facades, interior walls, etc.) for that floor will be automatically removed.",
//         type: "info",
//         autoClose: false,
//         playSound: true,
//       },
//       {
//         id: "feature-file-management",
//         title: "New Feature: Pv file update/upload/delete",
//         message: "now you can delete specific pv file, and new pv files",
//         type: "info",
//         autoClose: false,
//         playSound: false, // Only play sound for the first notification
//       },
//       {
//         id: "Change floor order",
//         title: "New Feature: changing floor order",
//         message:
//           "now by drag and drop each floor level, you can change the order of a floor",
//         type: "info",
//         autoClose: false,
//         playSound: false,
//       },
//       // {
//       //   id: "Delete floor",
//       //   title: "New Feature: deleting floor",
//       //   message:
//       //     "now under the floor level section, by deleting specific floor, you can delete a level and the respective building structure for that level will be deleted",
//       //   type: "info",
//       //   autoClose: false,
//       //   playSound: false,
//       // },
//     ]);
//   }, [projectId]);

//   const addNotification = (notification) => {
//     setNotifications((prev) => [
//       ...prev,
//       {
//         id: notification.id || `notification-${Date.now()}`,
//         ...notification,
//       },
//     ]);
//   };

//   const removeNotification = (id) => {
//     setNotifications((prev) =>
//       prev.filter((notification) => notification.id !== id)
//     );
//   };

//   const fetchProjectData = async () => {
//     setLoading(true);
//     try {
//       const data = await apiClient.get("/api/project_info/", {
//         params: { project_id: projectId },
//         showToast: false,
//       });

//       if (data.length > 0 && data[0]) {
//         const parseJsonField = (field, defaultValue = []) => {
//           try {
//             return field ? JSON.parse(field) : defaultValue;
//           } catch (e) {
//             console.error(`Error parsing field:`, e);
//             return defaultValue;
//           }
//         };

//         setProjectData({
//           ceilingList: parseJsonField(data[0].ceiling_list),
//           floorList: parseJsonField(data[0].floor_list),
//           externalList: parseJsonField(data[0].external_list),
//           internalList: parseJsonField(data[0].internal_list),
//           doorsList: parseJsonField(data[0].doors),
//           stairsList: parseJsonField(data[0].stairs),
//           pvList: parseJsonField(data[0].pv_panels),
//         });
//       }
//       setError(null);
//     } catch (err) {
//       setError("Failed to load project data. Please try again.");
//       console.error("Error fetching data:", err);

//       addNotification({
//         title: "Error",
//         message: "Failed to load project data. Please try again.",
//         type: "error",
//         autoClose: true,
//         duration: 5000,
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const sortAssetsByFloorOrder = (assets, floorOrder) => {
//     const floorPositions = new Map();
//     floorOrder.forEach((floor, index) => {
//       floorPositions.set(floor, index);
//     });

//     return [...assets].sort((a, b) => {
//       const floorA = floorOrder.find((floor) => a.includes(floor));
//       const floorB = floorOrder.find((floor) => b.includes(floor));

//       if (floorA && floorB) {
//         return floorPositions.get(floorA) - floorPositions.get(floorB);
//       }

//       if (floorA) return -1;
//       if (floorB) return 1;

//       return 0;
//     });
//   };

//   const handleDeleteFloor = async (floorToDelete) => {
//     const token = localStorage.getItem("token");
//     const apiRoot = process.env.REACT_APP_API_ROOT || "";
//     const projectInfoService = new ProjectInfoService(apiRoot, token);

//     try {
//       const updatedData = { ...projectData };

//       updatedData.floorList = projectData.floorList.filter(
//         (floor) => floor !== floorToDelete
//       );

//       const floorPattern = new RegExp(floorToDelete, "i");

//       updatedData.externalList = projectData.externalList.filter(
//         (item) => !floorPattern.test(item)
//       );

//       updatedData.ceilingList = projectData.ceilingList.filter(
//         (item) => !floorPattern.test(item)
//       );

//       updatedData.internalList = projectData.internalList.filter(
//         (item) => !floorPattern.test(item)
//       );

//       updatedData.stairsList = projectData.stairsList.filter(
//         (item) => !floorPattern.test(item)
//       );

//       updatedData.doorsList = projectData.doorsList.filter(
//         (item) => !floorPattern.test(item)
//       );

//       await projectInfoService.updateListField(
//         projectId,
//         ProjectInfoFields.FLOOR_LIST,
//         updatedData.floorList,
//         { overwrite: true }
//       );

//       await projectInfoService.updateListField(
//         projectId,
//         ProjectInfoFields.EXTERNAL_LIST,
//         updatedData.externalList,
//         { overwrite: true }
//       );

//       await projectInfoService.updateListField(
//         projectId,
//         ProjectInfoFields.CEILING_LIST,
//         updatedData.ceilingList,
//         { overwrite: true }
//       );

//       await projectInfoService.updateListField(
//         projectId,
//         ProjectInfoFields.INTERNAL_LIST,
//         updatedData.internalList,
//         { overwrite: true }
//       );

//       await projectInfoService.updateListField(
//         projectId,
//         "stairs",
//         updatedData.stairsList,
//         { overwrite: true }
//       );

//       await projectInfoService.updateListField(
//         projectId,
//         "doors",
//         updatedData.doorsList,
//         { overwrite: true }
//       );

//       setProjectData(updatedData);

//       addNotification({
//         title: "Success",
//         message: `Successfully removed floor "${floorToDelete}" and all related assets`,
//         type: "success",
//         autoClose: true,
//         duration: 5000,
//       });
//     } catch (err) {
//       setError(`Failed to delete floor: ${err.message}`);
//       console.error("Error deleting floor:", err);

//       addNotification({
//         title: "Error",
//         message: `Failed to delete floor: ${err.message}`,
//         type: "error",
//         autoClose: true,
//         duration: 5000,
//       });
//     }
//   };

//   const handleSaveFloorOrder = async (newFloorOrder) => {
//     const token = localStorage.getItem("token");
//     const apiRoot = process.env.REACT_APP_API_ROOT || "";
//     const projectInfoService = new ProjectInfoService(apiRoot, token);

//     try {
//       const updatedData = { ...projectData };

//       updatedData.floorList = newFloorOrder;

//       updatedData.externalList = sortAssetsByFloorOrder(
//         projectData.externalList,
//         newFloorOrder
//       );
//       updatedData.ceilingList = sortAssetsByFloorOrder(
//         projectData.ceilingList,
//         newFloorOrder
//       );
//       updatedData.internalList = sortAssetsByFloorOrder(
//         projectData.internalList,
//         newFloorOrder
//       );
//       updatedData.stairsList = sortAssetsByFloorOrder(
//         projectData.stairsList,
//         newFloorOrder
//       );
//       updatedData.doorsList = sortAssetsByFloorOrder(
//         projectData.doorsList,
//         newFloorOrder
//       );

//       await projectInfoService.updateListField(
//         projectId,
//         ProjectInfoFields.FLOOR_LIST,
//         updatedData.floorList,
//         { overwrite: true }
//       );

//       await projectInfoService.updateListField(
//         projectId,
//         ProjectInfoFields.EXTERNAL_LIST,
//         updatedData.externalList,
//         { overwrite: true }
//       );

//       await projectInfoService.updateListField(
//         projectId,
//         ProjectInfoFields.CEILING_LIST,
//         updatedData.ceilingList,
//         { overwrite: true }
//       );

//       await projectInfoService.updateListField(
//         projectId,
//         ProjectInfoFields.INTERNAL_LIST,
//         updatedData.internalList,
//         { overwrite: true }
//       );

//       await projectInfoService.updateListField(
//         projectId,
//         "stairs",
//         updatedData.stairsList,
//         { overwrite: true }
//       );

//       await projectInfoService.updateListField(
//         projectId,
//         "doors",
//         updatedData.doorsList,
//         { overwrite: true }
//       );

//       setProjectData(updatedData);

//       addNotification({
//         title: "Success",
//         message: "Floor order and all assets have been successfully reordered",
//         type: "success",
//         autoClose: true,
//         duration: 5000,
//       });
//     } catch (err) {
//       setError(`Failed to update floor order: ${err.message}`);
//       console.error("Error updating floor order:", err);

//       addNotification({
//         title: "Error",
//         message: `Failed to update floor order: ${err.message}`,
//         type: "error",
//         autoClose: true,
//         duration: 5000,
//       });
//     }
//   };

//   const handleDelete = async (field, item) => {
//     const token = localStorage.getItem("token");
//     const apiRoot = process.env.REACT_APP_API_ROOT || "";
//     const projectInfoService = new ProjectInfoService(apiRoot, token);

//     try {
//       let fieldKey;
//       let stateKey;

//       switch (field) {
//         case ProjectInfoFields.EXTERNAL_LIST:
//           fieldKey = "external_list";
//           stateKey = "externalList";
//           break;
//         case ProjectInfoFields.CEILING_LIST:
//           fieldKey = "ceiling_list";
//           stateKey = "ceilingList";
//           break;
//         case ProjectInfoFields.INTERNAL_LIST:
//           fieldKey = "internal_list";
//           stateKey = "internalList";
//           break;
//         case ProjectInfoFields.FLOOR_LIST:
//           fieldKey = "floor_list";
//           stateKey = "floorList";
//           break;
//         case "stairs":
//           fieldKey = "stairs";
//           stateKey = "stairsList";
//           break;
//         case "doors":
//           fieldKey = "doors";
//           stateKey = "doorsList";
//           break;
//         case "pv_panels":
//           fieldKey = "pv_panels";
//           stateKey = "pvList";
//           break;
//         default:
//           throw new Error(`Unknown field: ${field}`);
//       }

//       const currentList = [...projectData[stateKey]];
//       const updatedList = currentList.filter((i) => i !== item);

//       await projectInfoService.updateListField(
//         projectId,
//         fieldKey,
//         updatedList,
//         { overwrite: true }
//       );

//       setProjectData((prev) => ({
//         ...prev,
//         [stateKey]: updatedList,
//       }));

//       addNotification({
//         title: "Success",
//         message: `Successfully removed "${item}"`,
//         type: "success",
//         autoClose: true,
//         duration: 5000,
//       });
//     } catch (err) {
//       setError(`Failed to delete item: ${err.message}`);
//       console.error("Error deleting item:", err);

//       addNotification({
//         title: "Error",
//         message: `Failed to delete item: ${err.message}`,
//         type: "error",
//         autoClose: true,
//         duration: 5000,
//       });
//     }
//   };

//   const handleUpload = async (field, item, newItem) => {
//     const token = localStorage.getItem("token");
//     const apiRoot = process.env.REACT_APP_API_ROOT || "";
//     const projectInfoService = new ProjectInfoService(apiRoot, token);

//     try {
//       let fieldKey;
//       let stateKey;

//       switch (field) {
//         case ProjectInfoFields.EXTERNAL_LIST:
//           fieldKey = "external_list";
//           stateKey = "externalList";
//           break;
//         case ProjectInfoFields.CEILING_LIST:
//           fieldKey = "ceiling_list";
//           stateKey = "ceilingList";
//           break;
//         case ProjectInfoFields.INTERNAL_LIST:
//           fieldKey = "internal_list";
//           stateKey = "internalList";
//           break;
//         case ProjectInfoFields.FLOOR_LIST:
//           fieldKey = "floor_list";
//           stateKey = "floorList";
//           break;
//         case "stairs":
//           fieldKey = "stairs";
//           stateKey = "stairsList";
//           break;
//         case "doors":
//           fieldKey = "doors";
//           stateKey = "doorsList";
//           break;
//         case "pv_panels":
//           fieldKey = "pv_panels";
//           stateKey = "pvList";
//           break;
//         default:
//           throw new Error(`Unknown field: ${field}`);
//       }

//       const currentList = [...projectData[stateKey]];

//       const updatedList = currentList.map((i) => (i === item ? newItem : i));

//       await projectInfoService.updateListField(
//         projectId,
//         fieldKey,
//         updatedList,
//         { overwrite: true }
//       );

//       setProjectData((prev) => ({
//         ...prev,
//         [stateKey]: updatedList,
//       }));

//       addNotification({
//         title: "Success",
//         message: `Successfully replaced "${item}" with "${newItem}"`,
//         type: "success",
//         autoClose: true,
//         duration: 5000,
//       });

//       setTimeout(() => {
//         fetchProjectData();
//       }, 1000);
//     } catch (err) {
//       setError(`Failed to update item: ${err.message}`);
//       console.error("Error updating item:", err);

//       addNotification({
//         title: "Error",
//         message: `Failed to update item: ${err.message}`,
//         type: "error",
//         autoClose: true,
//         duration: 5000,
//       });
//     }
//   };

//   const handlePvUpdate = async (updatedList) => {
//     setProjectData((prev) => ({
//       ...prev,
//       pvList: updatedList,
//     }));

//     addNotification({
//       title: "Success",
//       message: "PV panel list updated successfully",
//       type: "success",
//       autoClose: true,
//       duration: 5000,
//     });

//     fetchProjectData();
//   };

//   const handleBulkUpdate = () => {
//     addNotification({
//       title: "Success",
//       message: "All files have been successfully replaced",
//       type: "success",
//       autoClose: true,
//       duration: 5000,
//     });

//     fetchProjectData();
//     setShowBulkUpload(false);
//   };

//   if (loading) {
//     return (
//       <MainLayout>
//         <div className="min-h-screen bg-gray-50 py-8">
//           <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//             <div className="flex flex-col items-center justify-center py-12">
//               <div className="w-8 h-8 border-4 border-t-blue-500 border-b-blue-500 rounded-full animate-spin mb-4"></div>
//               <p className="text-gray-600">Loading project data...</p>
//             </div>
//           </div>
//         </div>
//       </MainLayout>
//     );
//   }

//   return (
//     <NotificationSoundProvider>
//       <MainLayout>
//         <div className="min-h-screen bg-gray-50 py-8">
//           <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//             <Card
//               title={`Scene Asset Manager - Project ${projectId}`}
//               subtitle="Manage your project's 3D assets"
//             >
//               <ErrorBanner message={error} />

//               <div className="px-6 py-4 border-t border-b border-gray-200">
//                 <SectionHeader title="Floor Management" />

//                 <DraggableFloorManager
//                   floors={projectData.floorList}
//                   onDeleteFloor={handleDeleteFloor}
//                   onSaveOrder={handleSaveFloorOrder}
//                   loading={loading}
//                 />

//                 <AssetListManager
//                   title="External/Facade Assets"
//                   items={projectData.externalList}
//                   onDelete={handleDelete}
//                   onUpload={handleUpload}
//                   apiField={ProjectInfoFields.EXTERNAL_LIST}
//                   projectId={projectId}
//                   loading={loading}
//                 />

//                 <AssetListManager
//                   title="Ceiling GLB Assets"
//                   items={projectData.ceilingList}
//                   onDelete={handleDelete}
//                   onUpload={handleUpload}
//                   apiField={ProjectInfoFields.CEILING_LIST}
//                   projectId={projectId}
//                   loading={loading}
//                 />

//                 <AssetListManager
//                   title="Internal Walls Assets"
//                   items={projectData.internalList}
//                   onDelete={handleDelete}
//                   onUpload={handleUpload}
//                   apiField={ProjectInfoFields.INTERNAL_LIST}
//                   projectId={projectId}
//                   loading={loading}
//                 />

//                 <AssetListManager
//                   title="Stairs GLB Assets"
//                   items={projectData.stairsList}
//                   onDelete={handleDelete}
//                   onUpload={handleUpload}
//                   apiField="stairs"
//                   projectId={projectId}
//                   loading={loading}
//                 />

//                 <AssetListManager
//                   title="Doors Assets"
//                   items={projectData.doorsList}
//                   onDelete={handleDelete}
//                   onUpload={handleUpload}
//                   apiField="doors"
//                   projectId={projectId}
//                   loading={loading}
//                 />

//                 <PvUploadManager
//                   items={projectData.pvList}
//                   onDelete={handleDelete}
//                   onUpload={handleUpload}
//                   projectId={projectId}
//                   onPvUpdate={handlePvUpdate}
//                   loading={loading}
//                   showUpload={showPvUpload}
//                   setShowUpload={setShowPvUpload}
//                 />
//               </div>

//               <div className="px-6 py-4 mt-6 border-t border-gray-200">
//                 <SectionHeader title="Project File Management" />
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
//                   <div className="p-4 bg-white rounded-lg border border-gray-200">
//                     <h3 className="font-medium text-gray-800 mb-2">
//                       Add More PV Files
//                     </h3>
//                     <p className="text-sm text-gray-600 mb-3">
//                       Upload additional PV panel GLB files to your project.
//                     </p>
//                     <button
//                       onClick={() => setShowPvUpload(true)}
//                       className="px-4 py-2 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700 flex items-center"
//                     >
//                       <FolderPlus size={16} className="mr-2" />
//                       Add PV Files
//                     </button>
//                   </div>

//                   <div className="p-4 bg-white rounded-lg border border-gray-200">
//                     <h3 className="font-medium text-gray-800 mb-2">
//                       Replace All GLB Files
//                     </h3>
//                     <p className="text-sm text-gray-600 mb-3">
//                       Upload a new ZIP file to completely replace all GLB files.
//                     </p>
//                     <button
//                       onClick={() => setShowBulkUpload(true)}
//                       className="px-4 py-2 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700 flex items-center"
//                     >
//                       <RefreshCw size={16} className="mr-2" />
//                       Replace All Files
//                     </button>
//                   </div>
//                 </div>

//                 {showBulkUpload && (
//                   <BulkUploadManager
//                     projectId={projectId}
//                     onClose={() => setShowBulkUpload(false)}
//                     onBulkUpdate={handleBulkUpdate}
//                   />
//                 )}
//               </div>

//               <div className="p-6">
//                 <PrimaryButton
//                   onClick={() => {
//                     fetchProjectData();
//                     addNotification({
//                       title: "Info",
//                       message: "Data refreshed successfully",
//                       type: "info",
//                       autoClose: true,
//                       duration: 3000,
//                     });
//                   }}
//                   className="mt-4"
//                 >
//                   Refresh Data
//                 </PrimaryButton>
//               </div>
//             </Card>
//           </div>
//         </div>

//         <PushNotificationManager
//           notifications={notifications}
//           onClose={removeNotification}
//         />
//       </MainLayout>
//     </NotificationSoundProvider>
//   );
// };

// export default SceneAssetManager;
import React, { useState, useEffect } from "react";
import { MainLayout } from "../components/layout/MainLayout";
import { 
  FolderPlus, 
  RefreshCw, 
  Box, 
  Settings, 
  Upload, 
  AlertCircle, 
  CheckCircle, 
  Loader, 
  Bell,
  Database,
  ArrowRight,
  Layers,
  Home,
  FileText,
  Stairs
} from "lucide-react";
import ErrorBanner from "../components/common/ErrorBanner";
import Card from "../components/common/Card";
import SectionHeader from "../components/common/SectionHeader";
import PrimaryButton from "../components/ui/PrimaryButton";
import apiClient from "../components/utils/apiClient";
import { useParams } from "react-router-dom";
import {
  ProjectInfoService,
  ProjectInfoFields,
} from "../components/services/ProjectInfoService";
import AssetListManager from "./AssetListManager";
import DraggableFloorManager from "./DraggableFloorManager";
import BulkUploadManager from "./BulkUploadManager";
import PvUploadManager from "./PvUploadManager";
import {
  PushNotification,
  PushNotificationManager,
  NotificationSoundProvider,
} from "./PushNotification";

// Reusable Components
const PageHeader = ({ 
  icon: Icon, 
  title, 
  subtitle, 
  iconGradient = "from-blue-600 to-indigo-600"
}) => (
  <div className="text-center mb-8">
    <div className={`inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br ${iconGradient} rounded-xl mb-4 shadow-lg`}>
      <Icon className="w-8 h-8 text-white" />
    </div>
    <h1 className="text-3xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent mb-3">
      {title}
    </h1>
    <p className="text-base text-slate-600 max-w-2xl mx-auto">
      {subtitle}
    </p>
  </div>
);

const SectionCard = ({ title, icon: Icon, gradient, children, className = "" }) => (
  <div className={`bg-white rounded-xl shadow-lg border border-slate-200 overflow-hidden mb-8 ${className}`}>
    <div className={`bg-gradient-to-r ${gradient} p-4 relative overflow-hidden`}>
      <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent"></div>
      <div className="relative z-10 flex items-center gap-3">
        <Icon className="w-5 h-5 text-white" />
        <h2 className="text-xl font-bold text-white">{title}</h2>
      </div>
      
      {/* Decorative Elements */}
      <div className="absolute -top-4 -right-4 w-12 h-12 bg-white/10 rounded-full"></div>
      <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-white/10 rounded-full"></div>
    </div>
    
    <div className="p-6">
      {children}
    </div>
  </div>
);

const ActionCard = ({ title, description, buttonText, buttonIcon: ButtonIcon, onClick, variant = "primary" }) => {
  const variants = {
    primary: "bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700",
    secondary: "bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700",
    success: "bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700"
  };

  return (
    <div className="group bg-white rounded-xl shadow-lg border border-slate-200 p-6 hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
      <h3 className="font-bold text-slate-800 mb-2 group-hover:text-blue-600 transition-colors duration-200">
        {title}
      </h3>
      <p className="text-sm text-slate-600 mb-4 leading-relaxed">
        {description}
      </p>
      <button
        onClick={onClick}
        className={`${variants[variant]} text-white px-4 py-2 rounded-lg font-semibold transition-all duration-200 shadow-md hover:shadow-lg flex items-center gap-2 text-sm`}
      >
        <ButtonIcon className="w-4 h-4" />
        {buttonText}
      </button>
    </div>
  );
};

const LoadingState = () => (
  <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center">
    <div className="text-center">
      <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-2xl mb-4 shadow-lg">
        <Loader className="w-8 h-8 text-white animate-spin" />
      </div>
      <h2 className="text-xl font-semibold text-slate-700">Loading Project Data...</h2>
      <p className="text-slate-500 mt-2">Please wait while we fetch your assets</p>
    </div>
  </div>
);

const NotificationCard = ({ notifications, onClose }) => {
  if (notifications.length === 0) return null;

  return (
    <div className="mb-8">
      <SectionCard
        title="Feature Updates"
        icon={Bell}
        gradient="from-amber-500 to-orange-600"
      >
        <div className="space-y-4">
          {notifications.map((notification) => (
            <div
              key={notification.id}
              className="bg-amber-50 border border-amber-200 rounded-lg p-4"
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <h4 className="font-semibold text-amber-800 mb-1">
                    {notification.title}
                  </h4>
                  <p className="text-amber-700 text-sm">
                    {notification.message}
                  </p>
                </div>
                <button
                  onClick={() => onClose(notification.id)}
                  className="text-amber-600 hover:text-amber-800 transition-colors duration-200 ml-4"
                >
                  ×
                </button>
              </div>
            </div>
          ))}
        </div>
      </SectionCard>
    </div>
  );
};

const SceneAssetManager = () => {
  const { projectId } = useParams();

  const [projectData, setProjectData] = useState({
    ceilingList: [],
    floorList: [],
    externalList: [],
    internalList: [],
    doorsList: [],
    stairsList: [],
    pvList: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [showBulkUpload, setShowBulkUpload] = useState(false);
  const [showPvUpload, setShowPvUpload] = useState(false);

  useEffect(() => {
    fetchProjectData();

    setNotifications([
      {
        id: "feature-floor-deletion",
        title: "New Feature: Floor Deletion",
        message:
          "When you delete a floor from the Floor List, all related assets (facades, interior walls, etc.) for that floor will be automatically removed.",
        type: "info",
        autoClose: false,
        playSound: true,
      },
      {
        id: "feature-file-management",
        title: "New Feature: PV File Management",
        message: "Now you can delete specific PV files and upload new PV files with enhanced management.",
        type: "info",
        autoClose: false,
        playSound: false,
      },
      {
        id: "Change floor order",
        title: "New Feature: Floor Ordering",
        message:
          "Now by drag and drop each floor level, you can change the order of floors dynamically.",
        type: "info",
        autoClose: false,
        playSound: false,
      },
    ]);
  }, [projectId]);

  const addNotification = (notification) => {
    setNotifications((prev) => [
      ...prev,
      {
        id: notification.id || `notification-${Date.now()}`,
        ...notification,
      },
    ]);
  };

  const removeNotification = (id) => {
    setNotifications((prev) =>
      prev.filter((notification) => notification.id !== id)
    );
  };

  const fetchProjectData = async () => {
    setLoading(true);
    try {
      const data = await apiClient.get("/api/project_info/", {
        params: { project_id: projectId },
        showToast: false,
      });

      if (data.length > 0 && data[0]) {
        const parseJsonField = (field, defaultValue = []) => {
          try {
            return field ? JSON.parse(field) : defaultValue;
          } catch (e) {
            console.error(`Error parsing field:`, e);
            return defaultValue;
          }
        };

        setProjectData({
          ceilingList: parseJsonField(data[0].ceiling_list),
          floorList: parseJsonField(data[0].floor_list),
          externalList: parseJsonField(data[0].external_list),
          internalList: parseJsonField(data[0].internal_list),
          doorsList: parseJsonField(data[0].doors),
          stairsList: parseJsonField(data[0].stairs),
          pvList: parseJsonField(data[0].pv_panels),
        });
      }
      setError(null);
    } catch (err) {
      setError("Failed to load project data. Please try again.");
      console.error("Error fetching data:", err);

      addNotification({
        title: "Error",
        message: "Failed to load project data. Please try again.",
        type: "error",
        autoClose: true,
        duration: 5000,
      });
    } finally {
      setLoading(false);
    }
  };

  const sortAssetsByFloorOrder = (assets, floorOrder) => {
    const floorPositions = new Map();
    floorOrder.forEach((floor, index) => {
      floorPositions.set(floor, index);
    });

    return [...assets].sort((a, b) => {
      const floorA = floorOrder.find((floor) => a.includes(floor));
      const floorB = floorOrder.find((floor) => b.includes(floor));

      if (floorA && floorB) {
        return floorPositions.get(floorA) - floorPositions.get(floorB);
      }

      if (floorA) return -1;
      if (floorB) return 1;

      return 0;
    });
  };

  const handleDeleteFloor = async (floorToDelete) => {
    const token = localStorage.getItem("token");
    const apiRoot = process.env.REACT_APP_API_ROOT || "";
    const projectInfoService = new ProjectInfoService(apiRoot, token);

    try {
      const updatedData = { ...projectData };

      updatedData.floorList = projectData.floorList.filter(
        (floor) => floor !== floorToDelete
      );

      const floorPattern = new RegExp(floorToDelete, "i");

      updatedData.externalList = projectData.externalList.filter(
        (item) => !floorPattern.test(item)
      );

      updatedData.ceilingList = projectData.ceilingList.filter(
        (item) => !floorPattern.test(item)
      );

      updatedData.internalList = projectData.internalList.filter(
        (item) => !floorPattern.test(item)
      );

      updatedData.stairsList = projectData.stairsList.filter(
        (item) => !floorPattern.test(item)
      );

      updatedData.doorsList = projectData.doorsList.filter(
        (item) => !floorPattern.test(item)
      );

      await projectInfoService.updateListField(
        projectId,
        ProjectInfoFields.FLOOR_LIST,
        updatedData.floorList,
        { overwrite: true }
      );

      await projectInfoService.updateListField(
        projectId,
        ProjectInfoFields.EXTERNAL_LIST,
        updatedData.externalList,
        { overwrite: true }
      );

      await projectInfoService.updateListField(
        projectId,
        ProjectInfoFields.CEILING_LIST,
        updatedData.ceilingList,
        { overwrite: true }
      );

      await projectInfoService.updateListField(
        projectId,
        ProjectInfoFields.INTERNAL_LIST,
        updatedData.internalList,
        { overwrite: true }
      );

      await projectInfoService.updateListField(
        projectId,
        "stairs",
        updatedData.stairsList,
        { overwrite: true }
      );

      await projectInfoService.updateListField(
        projectId,
        "doors",
        updatedData.doorsList,
        { overwrite: true }
      );

      setProjectData(updatedData);

      addNotification({
        title: "Success",
        message: `Successfully removed floor "${floorToDelete}" and all related assets`,
        type: "success",
        autoClose: true,
        duration: 5000,
      });
    } catch (err) {
      setError(`Failed to delete floor: ${err.message}`);
      console.error("Error deleting floor:", err);

      addNotification({
        title: "Error",
        message: `Failed to delete floor: ${err.message}`,
        type: "error",
        autoClose: true,
        duration: 5000,
      });
    }
  };

  const handleSaveFloorOrder = async (newFloorOrder) => {
    const token = localStorage.getItem("token");
    const apiRoot = process.env.REACT_APP_API_ROOT || "";
    const projectInfoService = new ProjectInfoService(apiRoot, token);

    try {
      const updatedData = { ...projectData };

      updatedData.floorList = newFloorOrder;

      updatedData.externalList = sortAssetsByFloorOrder(
        projectData.externalList,
        newFloorOrder
      );
      updatedData.ceilingList = sortAssetsByFloorOrder(
        projectData.ceilingList,
        newFloorOrder
      );
      updatedData.internalList = sortAssetsByFloorOrder(
        projectData.internalList,
        newFloorOrder
      );
      updatedData.stairsList = sortAssetsByFloorOrder(
        projectData.stairsList,
        newFloorOrder
      );
      updatedData.doorsList = sortAssetsByFloorOrder(
        projectData.doorsList,
        newFloorOrder
      );

      await projectInfoService.updateListField(
        projectId,
        ProjectInfoFields.FLOOR_LIST,
        updatedData.floorList,
        { overwrite: true }
      );

      await projectInfoService.updateListField(
        projectId,
        ProjectInfoFields.EXTERNAL_LIST,
        updatedData.externalList,
        { overwrite: true }
      );

      await projectInfoService.updateListField(
        projectId,
        ProjectInfoFields.CEILING_LIST,
        updatedData.ceilingList,
        { overwrite: true }
      );

      await projectInfoService.updateListField(
        projectId,
        ProjectInfoFields.INTERNAL_LIST,
        updatedData.internalList,
        { overwrite: true }
      );

      await projectInfoService.updateListField(
        projectId,
        "stairs",
        updatedData.stairsList,
        { overwrite: true }
      );

      await projectInfoService.updateListField(
        projectId,
        "doors",
        updatedData.doorsList,
        { overwrite: true }
      );

      setProjectData(updatedData);

      addNotification({
        title: "Success",
        message: "Floor order and all assets have been successfully reordered",
        type: "success",
        autoClose: true,
        duration: 5000,
      });
    } catch (err) {
      setError(`Failed to update floor order: ${err.message}`);
      console.error("Error updating floor order:", err);

      addNotification({
        title: "Error",
        message: `Failed to update floor order: ${err.message}`,
        type: "error",
        autoClose: true,
        duration: 5000,
      });
    }
  };

  const handleDelete = async (field, item) => {
    const token = localStorage.getItem("token");
    const apiRoot = process.env.REACT_APP_API_ROOT || "";
    const projectInfoService = new ProjectInfoService(apiRoot, token);

    try {
      let fieldKey;
      let stateKey;

      switch (field) {
        case ProjectInfoFields.EXTERNAL_LIST:
          fieldKey = "external_list";
          stateKey = "externalList";
          break;
        case ProjectInfoFields.CEILING_LIST:
          fieldKey = "ceiling_list";
          stateKey = "ceilingList";
          break;
        case ProjectInfoFields.INTERNAL_LIST:
          fieldKey = "internal_list";
          stateKey = "internalList";
          break;
        case ProjectInfoFields.FLOOR_LIST:
          fieldKey = "floor_list";
          stateKey = "floorList";
          break;
        case "stairs":
          fieldKey = "stairs";
          stateKey = "stairsList";
          break;
        case "doors":
          fieldKey = "doors";
          stateKey = "doorsList";
          break;
        case "pv_panels":
          fieldKey = "pv_panels";
          stateKey = "pvList";
          break;
        default:
          throw new Error(`Unknown field: ${field}`);
      }

      const currentList = [...projectData[stateKey]];
      const updatedList = currentList.filter((i) => i !== item);

      await projectInfoService.updateListField(
        projectId,
        fieldKey,
        updatedList,
        { overwrite: true }
      );

      setProjectData((prev) => ({
        ...prev,
        [stateKey]: updatedList,
      }));

      addNotification({
        title: "Success",
        message: `Successfully removed "${item}"`,
        type: "success",
        autoClose: true,
        duration: 5000,
      });
    } catch (err) {
      setError(`Failed to delete item: ${err.message}`);
      console.error("Error deleting item:", err);

      addNotification({
        title: "Error",
        message: `Failed to delete item: ${err.message}`,
        type: "error",
        autoClose: true,
        duration: 5000,
      });
    }
  };

  const handleUpload = async (field, item, newItem) => {
    const token = localStorage.getItem("token");
    const apiRoot = process.env.REACT_APP_API_ROOT || "";
    const projectInfoService = new ProjectInfoService(apiRoot, token);

    try {
      let fieldKey;
      let stateKey;

      switch (field) {
        case ProjectInfoFields.EXTERNAL_LIST:
          fieldKey = "external_list";
          stateKey = "externalList";
          break;
        case ProjectInfoFields.CEILING_LIST:
          fieldKey = "ceiling_list";
          stateKey = "ceilingList";
          break;
        case ProjectInfoFields.INTERNAL_LIST:
          fieldKey = "internal_list";
          stateKey = "internalList";
          break;
        case ProjectInfoFields.FLOOR_LIST:
          fieldKey = "floor_list";
          stateKey = "floorList";
          break;
        case "stairs":
          fieldKey = "stairs";
          stateKey = "stairsList";
          break;
        case "doors":
          fieldKey = "doors";
          stateKey = "doorsList";
          break;
        case "pv_panels":
          fieldKey = "pv_panels";
          stateKey = "pvList";
          break;
        default:
          throw new Error(`Unknown field: ${field}`);
      }

      const currentList = [...projectData[stateKey]];

      const updatedList = currentList.map((i) => (i === item ? newItem : i));

      await projectInfoService.updateListField(
        projectId,
        fieldKey,
        updatedList,
        { overwrite: true }
      );

      setProjectData((prev) => ({
        ...prev,
        [stateKey]: updatedList,
      }));

      addNotification({
        title: "Success",
        message: `Successfully replaced "${item}" with "${newItem}"`,
        type: "success",
        autoClose: true,
        duration: 5000,
      });

      setTimeout(() => {
        fetchProjectData();
      }, 1000);
    } catch (err) {
      setError(`Failed to update item: ${err.message}`);
      console.error("Error updating item:", err);

      addNotification({
        title: "Error",
        message: `Failed to update item: ${err.message}`,
        type: "error",
        autoClose: true,
        duration: 5000,
      });
    }
  };

  const handlePvUpdate = async (updatedList) => {
    setProjectData((prev) => ({
      ...prev,
      pvList: updatedList,
    }));

    addNotification({
      title: "Success",
      message: "PV panel list updated successfully",
      type: "success",
      autoClose: true,
      duration: 5000,
    });

    fetchProjectData();
  };

  const handleBulkUpdate = () => {
    addNotification({
      title: "Success",
      message: "All files have been successfully replaced",
      type: "success",
      autoClose: true,
      duration: 5000,
    });

    fetchProjectData();
    setShowBulkUpload(false);
  };

  if (loading) {
    return (
      <MainLayout>
        <LoadingState />
      </MainLayout>
    );
  }

  return (
    <NotificationSoundProvider>
      <MainLayout>
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 p-6">
          <div className="max-w-7xl mx-auto">
            
            <PageHeader
              icon={Box}
              title="Scene Asset Manager"
              subtitle={`Manage your project's 3D assets and building components for Project ${projectId}`}
            />

            {/* Feature Notifications */}
            <NotificationCard
              notifications={notifications}
              onClose={removeNotification}
            />

            {/* Error Banner */}
            {error && (
              <div className="bg-white rounded-xl shadow-lg border border-red-200 overflow-hidden mb-8">
                <div className="bg-gradient-to-r from-red-500 to-pink-600 p-4">
                  <div className="flex items-center gap-3">
                    <AlertCircle className="w-5 h-5 text-white" />
                    <h2 className="text-xl font-bold text-white">Error</h2>
                  </div>
                </div>
                <div className="p-6">
                  <p className="text-red-600">{error}</p>
                </div>
              </div>
            )}

            {/* Floor Management */}
            <SectionCard
              title="Floor Management"
              icon={Layers}
              gradient="from-blue-600 to-indigo-600"
            >
              <DraggableFloorManager
                floors={projectData.floorList}
                onDeleteFloor={handleDeleteFloor}
                onSaveOrder={handleSaveFloorOrder}
                loading={loading}
              />
            </SectionCard>

            {/* Asset Management */}
            <SectionCard
              title="Asset Management"
              icon={Database}
              gradient="from-indigo-600 to-purple-600"
            >
              <div className="space-y-6">
                <AssetListManager
                  title="External/Facade Assets"
                  items={projectData.externalList}
                  onDelete={handleDelete}
                  onUpload={handleUpload}
                  apiField={ProjectInfoFields.EXTERNAL_LIST}
                  projectId={projectId}
                  loading={loading}
                />

                <AssetListManager
                  title="Ceiling GLB Assets"
                  items={projectData.ceilingList}
                  onDelete={handleDelete}
                  onUpload={handleUpload}
                  apiField={ProjectInfoFields.CEILING_LIST}
                  projectId={projectId}
                  loading={loading}
                />

                <AssetListManager
                  title="Internal Walls Assets"
                  items={projectData.internalList}
                  onDelete={handleDelete}
                  onUpload={handleUpload}
                  apiField={ProjectInfoFields.INTERNAL_LIST}
                  projectId={projectId}
                  loading={loading}
                />

                <AssetListManager
                  title="Stairs GLB Assets"
                  items={projectData.stairsList}
                  onDelete={handleDelete}
                  onUpload={handleUpload}
                  apiField="stairs"
                  projectId={projectId}
                  loading={loading}
                />

                <AssetListManager
                  title="Doors Assets"
                  items={projectData.doorsList}
                  onDelete={handleDelete}
                  onUpload={handleUpload}
                  apiField="doors"
                  projectId={projectId}
                  loading={loading}
                />

                <PvUploadManager
                  items={projectData.pvList}
                  onDelete={handleDelete}
                  onUpload={handleUpload}
                  projectId={projectId}
                  onPvUpdate={handlePvUpdate}
                  loading={loading}
                  showUpload={showPvUpload}
                  setShowUpload={setShowPvUpload}
                />
              </div>
            </SectionCard>

            {/* File Management Actions */}
            <SectionCard
              title="Project File Management"
              icon={Upload}
              gradient="from-purple-600 to-pink-600"
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <ActionCard
                  title="Add More PV Files"
                  description="Upload additional PV panel GLB files to your project with enhanced file management capabilities."
                  buttonText="Add PV Files"
                  buttonIcon={FolderPlus}
                  onClick={() => setShowPvUpload(true)}
                  variant="primary"
                />

                <ActionCard
                  title="Replace All GLB Files"
                  description="Upload a new ZIP file to completely replace all GLB files in your project at once."
                  buttonText="Replace All Files"
                  buttonIcon={RefreshCw}
                  onClick={() => setShowBulkUpload(true)}
                  variant="secondary"
                />
              </div>

              {showBulkUpload && (
                <div className="mt-6 p-6 bg-slate-50 rounded-xl border border-slate-200">
                  <BulkUploadManager
                    projectId={projectId}
                    onClose={() => setShowBulkUpload(false)}
                    onBulkUpdate={handleBulkUpdate}
                  />
                </div>
              )}
            </SectionCard>

            {/* Refresh Action */}
            <div className="text-center">
              <button
                onClick={() => {
                  fetchProjectData();
                  addNotification({
                    title: "Info",
                    message: "Data refreshed successfully",
                    type: "info",
                    autoClose: true,
                    duration: 3000,
                  });
                }}
                className="group bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 flex items-center gap-3 mx-auto"
              >
                <RefreshCw className="w-5 h-5 group-hover:rotate-180 transition-transform duration-500" />
                Refresh All Data
              </button>
            </div>
          </div>
        </div>

        <PushNotificationManager
          notifications={notifications}
          onClose={removeNotification}
        />
      </MainLayout>
    </NotificationSoundProvider>
  );
};

export default SceneAssetManager;